import { Card, styled } from "@mui/material";
import { IStyledCardProps } from "./types";

const StyledCard = styled(Card, {
    shouldForwardProp: prop => prop !== "customBgColor"
})<IStyledCardProps>(({theme, customBgColor})=>({
    borderRadius: (theme as any).shape.border.general.radius[8],
    backgroundColor: `${customBgColor === "black" ? (theme as any).palette.neutral.darkest : (theme as any).palette.neutral.lighter}`,
    padding: theme.spacing(1, 2),
    boxSizing: 'border-box',
}))

export {StyledCard}